module.exports = __webpack_public_path__ + "img/arrow-right-blue.4ca9d6d2.svg";